import { useEnrichmentCredits } from '../EnrichmentCreditsProvider';
export const useModalBulk = () => {
  const exports = useEnrichmentCredits();
  return Object.assign({}, exports);
};